/** Generate by swagger-axios-codegen */
// tslint:disable
/* eslint-disable */
import { AxiosInstance, AxiosRequestConfig } from "axios";
import ApiHelper from "@/services/Infrastructure/ApiHelper";

export interface IRequestOptions {
    headers?: any;
    baseURL?: string;
    responseType?: string;
}

export interface IRequestConfig extends AxiosRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error("please inject yourself instance like axios  ");
    }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
    const configs: IRequestConfig = { ...options, method, url };
    configs.headers = {
        ...options.headers,
        "Content-Type": contentType,
    };
    return configs;
}

export var basePath = ApiHelper.baseURL;

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class Document {
    /**  */
    "docTypeId"?: number;

    /**  */
    "number"?: string;

    /**  */
    "seria"?: string;

    /**  */
    "docDate"?: Date;

    /**  */
    "endDate"?: Date;

    /**  */
    "countryCode"?: string;

    /**  */
    "placeOfIssue"?: string;

    /**  */
    "divisionCode"?: string;

    constructor(data: undefined | any = {}) {
        this["docTypeId"] = data["docTypeId"] ?? 1;
        this["number"] = ""; //data['number'];
        this["seria"] = ""; //data['seria'];
        this["docDate"] = null; //data['docDate'];
        this["endDate"] = null; //data['endDate'];
        this["countryCode"] = "643"; //data['countryCode'];
        this["placeOfIssue"] = null; //data['placeOfIssue'];
        this["divisionCode"] = null; //data['divisionCode'];
    }
}

export class Car {
    /**  */
    "markId"?: string;

    /**  */
    "modelId"?: string;

    /**  */
    "autoMark"?: string;

    /**  */
    "autoModel"?: string;

    /**  */
    "modificationId"?: number;

    /**  */
    "yearIssue"?: number;

    /**  */
    "withUseTrailer"?: boolean;

    /**  */
    "power"?: number;

    /**  */
    "licensePlate"?: string;

    /**  */
    "vin"?: string;

    /**  */
    "bodyNumber"?: string;

    /**  */
    "chassisNumber"?: string;

    /**  */
    //'ticketCarLater'?: boolean;

    /**  */
    //'ticketCar'?: string;

    /**  */
    //'ticketCarNumber'?: string;

    /**  */
    //'ticketCarYear'?: number;

    /**  */
    //'ticketCarMonth'?: number;

    /**  */
    //'ticketDiagnosticDate'?: Date;

    /**  */
    //'ticketDiagnosticStartDate'?: Date;

    /**  */
    "documentCar"?: Document;

    /**  */
    "documentsCar"?: Document[];

    withOutGosSign?: boolean;
    constructor(data: undefined | any = {}) {
        this["markId"] = null; //data['markId'];
        this["modelId"] = null; //data['modelId'];
        this["autoMark"] = null; //data['autoMark'];
        this["autoModel"] = null; //data['autoModel'];
        this["modificationId"] = null; //data['modificationId'];
        this["yearIssue"] = null; //data['yearIssue'];
        this["withUseTrailer"] = false; //data['withUseTrailer'];
        this["power"] = null; //data['power'];
        this["licensePlate"] = null; //data['licensePlate'];
        this["vin"] = null; //data['vin'];
        this["bodyNumber"] = null; //data['bodyNumber'];
        this["chassisNumber"] = null; //data['chassisNumber'];
        this["ticketCarLater"] = null; //data['ticketCarLater'];
        this["ticketCar"] = null; //data['ticketCar'];
        this["ticketCarNumber"] = null; //data['ticketCarNumber'];
        this["ticketCarYear"] = null; //data['ticketCarYear'];
        this["ticketCarMonth"] = null; //data['ticketCarMonth'];
        this["ticketDiagnosticDate"] = null; //data['ticketDiagnosticDate'];
        this["ticketDiagnosticStartDate"] = null; //data['ticketDiagnosticStartDate'];
        this["documentCar"] = new Document({ docTypeId: 30 }); // null//data['documentCar'];
        this["documentsCar"] = []; // null//data['documentCar'];
        this["withOutGosSign"] = false;
    }
}

export class Address {
    /**  */
    "state"?: string;

    /**  */
    "region"?: string;

    /**  */
    "city"?: string;

    /**  */
    "street"?: string;

    /**  */
    "house"?: string;

    /**  */
    "building"?: string;

    /**  */
    "apartment"?: string;

    /**  */
    "zip"?: string;

    /**  */
    "fiasId"?: string;

    /**  */
    "cityFiasId"?: string;

    /**  */
    "streetFiasId"?: string;

    /**  */
    "kladrId"?: string;

    /**  */
    "value"?: string;
    "okato"?: string;

    constructor(data: undefined | any = {}) {
        this["state"] = null; //data['state'];
        this["region"] = null; //data['region'];
        this["city"] = null; //data['city'];
        this["street"] = null; //data['street'];
        this["house"] = null; //data['house'];
        this["building"] = null; //data['building'];
        this["apartment"] = null; //data['apartment'];
        this["zip"] = null; //data['zip'];
        this["fiasId"] = null; //data['fiasId'];
        this["cityFiasId"] = null; //data['cityFiasId'];
        this["streetFiasId"] = null; //data['streetFiasId'];
        this["kladrId"] = null; //data['kladrId'];
        this["value"] = ""; //data['value'];
        this["okato"] = null;
    }
}

export class Person {
    isWithoutLastName?: boolean; // front-only
    "name"?: string;

    /**  */
    "surname"?: string;

    /**  */
    "patronymic"?: string;

    /**  */
    "gender"?: Sex;

    /**  */
    "birthDate"?: Date;

    /**  */
    "phone"?: string;

    /**  */
    "email"?: string;

    /**  */
    "passport"?: Document;

    /**  */
    "address"?: Address;

    constructor(data: undefined | any = {}) {
        this["name"] = ""; //data['name'];
        this["surname"] = ""; //data['surname'];
        this["patronymic"] = ""; //data['patronymic'];
        this["gender"] = Sex.Male; //data['gender'];
        this["birthDate"] = null; //data['birthDate'];
        this["phone"] = ""; //data['phone'];
        this["email"] = ""; //data['email'];
        this["passport"] = new Document({ docTypeId: 1 }); //data['passport'];
        this["address"] = new Address(); //data['address'];
    }
}

export class Driver {
    isWithoutLastName: boolean; // front-only
    "person"?: Person;

    /**  */
    "driverLicense"?: Document;

    /**  */
    "oldDriverLicense"?: Document;
    oldSurname?: string;
    /**  */
    "firstLicenseDate"?: Date;

    /**  */
    "type"?: DriverType;

    /**  */
    "kbmJson"?: string;

    constructor(data: undefined | any = {}) {
        this["person"] = new Person(); //data['person'];
        this["driverLicense"] = new Document({ docTypeId: 1 }); //data['driverLicense'];
        this["oldDriverLicense"] = new Document({ docTypeId: 1 }); //data['driverLicense'];
        this["firstLicenseDate"] = null; //data['firstLicenseDate'];
        this.oldSurname = "";
        this["type"] = DriverType.Other; //data['type'];
        this["kbmJson"] = null; //data['kbmJson'];
    }
}

export class InsuranceCard {
    id?: number | string = null;
    guid?: string = null;

    get insurerIsOwner(): boolean {
        if (!this.insurer || !this.owner) return false;
        return this.insurer.passport?.seria == this.owner.passport?.seria && this.insurer.passport?.number == this.owner.passport?.number;
    }
    get endDate(): Date {
        /*const bTime = this.beginDate?.getTime?.();
        if (!bTime) return null;*/
        return new Date(this.beginDate).addMonths(this.insuranceMonth).addDays(-1);
    }
    get haveDoubleDrivers() {
        let isValid = false;
        let driverLicenses = this.drivers.map((x) => x.driverLicense);
        driverLicenses.forEach((item) => {
            let licenses = driverLicenses.filter((x) => x?.seria == item?.seria && x?.number == item?.number);
            if (licenses.length >= 2) isValid = true;
        });
        return isValid;
    }

    /**  */
    "beginDate"?: Date;

    /**  */
    "insuranceMonth"?: number;

    /**  */
    "prevPolicySerial"?: string;

    /**  */
    "prevPolicyNumber"?: string;

    /**  */
    "car"?: Car;

    /**  */
    "insurer"?: Person;

    /**  */
    "owner"?: Person;

    /**  */
    "drivers"?: Driver[];
    constructor(data: undefined | any = {}) {
        this["beginDate"] = new Date().addDays(4); //data['beginDate'];
        this["insuranceMonth"] = 12; //data['insuranceMonth'];
        this["prevPolicySerial"] = null; //data['prevPolicySerial'];
        this["prevPolicyNumber"] = null; //data['prevPolicyNumber'];
        this["car"] = new Car(); //data['car'];
        this["insurer"] = new Person(); //data['insurer'];
        this["owner"] = new Person(); //data['owner'];
        this["drivers"] = [new Driver()]; //data['drivers'];
        this["calcStates"] = [];
    }
}
export class ApiResponse<T = void> {
    "error"?: string = "";
    "success"?: boolean = false;
    "data"?: T = null;
}

export class CompanyResponse {
    /**  */
    "code"?: string; //icname

    /**  */
    "title"?: string;

    /**  */
    "id"?: string;

    /**  */
    "conversionRating"?: string;

    /**  */
    "reliabilityRating"?: string;

    constructor(data: undefined | any = {}) {
        this["code"] = null; //data['code'];
        this["title"] = null; //data['title'];
        this["id"] = null; //data['title'];
        this["conversionRating"] = ""; //data['title'];
        this["reliabilityRating"] = ""; //data['title'];
    }
}

export class MarkResponse {
    /**  */
    "id"?: string;

    /**  */
    "title"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = null; //data['id'];
        this["title"] = null; //data['title'];
    }
}

export class ModelResponse {
    /**  */
    "id"?: string;

    /**  */
    "title"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = null; //data['id'];
        this["title"] = null; //data['title'];
    }
}

export class ModificationResponse {
    /**  */
    "id"?: number;

    /**  */
    "title"?: string;

    /**  */
    "manufactureStart"?: number;

    /**  */
    "manufactureEnd"?: number;

    /**  */
    "power"?: number;

    get viewTitle(): string {
        return `${this.power ? this.power + " л.с. - " : ""} ${this.title}`;
    }

    constructor(data: undefined | any = {}) {
        this["id"] = null; //data['id'];
        this["title"] = null; //data['title'];
        this["manufactureStart"] = null; //data['manufactureStart'];
        this["manufactureEnd"] = null; //data['manufactureEnd'];
        this["power"] = null; //data['power'];
    }
}

export class KbmReponse {
    /**  */
    "value"?: number;

    constructor(data: undefined | any = {}) {
        this["value"] = null; //data['value'];
    }
}

export class DkRequest {
    /**  */
    "identifierType"?: IdentifierType;

    /**  */
    "value"?: string;

    constructor(data: undefined | any = {}) {
        this["identifierType"] = null;
        this["value"] = null;
    }
}

export class DkResponse {
    /**  */
    "number"?: string;

    /**  */
    "validTo"?: Date;
    beginFrom?: Date;

    constructor(data: undefined | any = {}) {
        this["number"] = null; //data['number'];
        this["validTo"] = null; //data['validTo'];
        this["beginFrom"] = null;
    }
}

export class AutocodeResponse {
    /**  */
    "power"?: number;

    /**  */
    "modelId"?: string;

    /**  */
    "markId"?: string;

    /**  */
    "vin"?: string;
    bodyNumber?: string;
    chassisNumber?: string;

    /**  */
    "licensePlate"?: string;

    /**  */
    "sts"?: string;

    /**  */
    "year"?: number;
    ptsDate?: Date;
    ptsNumber?: string;
    ptsSeries?: string;

    stsDate?: Date;
    stsNumber?: string;
    stsSeries?: string;

    constructor(data: undefined | any = {}) {
        this["power"] = null; //data['power'];
        this["modelId"] = null; //data['modelId'];
        this["markId"] = null; //data['markId'];
        this["vin"] = null; //data['vin'];
        this["licensePlate"] = null; //data['licensePlate'];
        this["sts"] = null; //data['sts'];
        this["year"] = null; //data['year'];
    }
}

export class AutocodeInfoResponse {
    /**  */
    "report"?: AutocodeResponse;

    /**  */
    "dkResponse"?: DkResponse;

    constructor(data: undefined | any = {}) {
        this["report"] = data["report"];
        this["dkResponse"] = data["dkResponse"];
    }
}

export enum ICStickerIcon {
    Star = 'Star',
};

export interface StickerSettings {
    text?: string,
    icon?: ICStickerIcon,
    backgroundColor?: string,
    foregroundColor?: string,
};

export interface PriorityICSetting {
    name: string
    seq: number
    stickerInfo: StickerSettings
};

export class Widget {
    "id"?: string;
    /**  */
    "title"?: string;

    /**  */
    "titleOn"?: boolean;

    /**  */
    "subtitle"?: string;

    /**  */
    "subtitleOn"?: boolean;

    /**  */
    "width"?: string;

    /**  */
    "gosSignOn"?: boolean;

    /**  */
    "color"?: string;

    /**  */
    "borderOn"?: boolean;

    /**  */
    "agentId"?: number;

    /**  */
    "isDeleted"?: boolean;

    "showPreviousCalculations"?: boolean;

    hideStepsPanel?: boolean;

    hideMobileWelcomeHeader?: boolean;

    homeScreenImage?: string;

    buttonsShadowStyle?: string;

    validationColor?: string;

    isFastCalcDisabled?: boolean;

    insuranceProviderSettings: PriorityICSetting[];

    constructor(data: undefined | any = {}) {
        (this["id"] = null), (this["title"] = null); //data['title'];
        this["titleOn"] = null; //data['titleOn'];
        this["subtitle"] = null; //data['subtitle'];
        this["subtitleOn"] = null; //data['subtitleOn'];
        this["width"] = null; //data['width'];
        this["gosSignOn"] = null; //data['gosSignOn'];
        this["color"] = null; //data['color'];
        this["borderOn"] = null; //data['borderOn'];
        this["agentId"] = null; //data['borderOn'];
        this["isDeleted"] = null; //data['borderOn'];
        this["showPreviousCalculations"] = null; //data['borderOn'];
        this["hideStepsPanel"] = null; //data['hideStepsPanel'];
        this["homeScreenImage"] = null; //data['homeScreenImage'];
        this["buttonsShadowStyle"] = null; //data['buttonsShadowStyle'];
    }
}

export enum Sex {
    Male = 1,
    Female = 2,
}

export enum DriverType {
    Insurer = 1,
    Owner = 2,
    Other = 3,
}

export enum IdentifierType {
    Vin,
    LicensePlate,
    BodyNumber,
    ChassisNumber,
}

export enum OTPBankGender {
    Male = "m",
    Female = "f",
}
export class TokenData {
    clientId: string = "";
    personalData: PersonalData = null;
    // complianceData: ComplianceData = null;
    // salesData: SalesData = null;
    // accounts: Account[] = [];
}

export class PersonalData {
    firstName: string = "";
    lastName: string = "";
    middleName: string = "";
    gender: OTPBankGender = null;
    citizenship: string = "";
    /** assuming xxxxyyyyyy format */
    passportNumber: string = "";
    passportIssueDate: Date = null;
    passportIssuer: string = "";
    passportIssuerCode: string = "";
    birthDate: Date = null;
    birthPlace: string = "";
    registrationAddress: string = "";
    actualAddress: string = "";
    phone: string = "";
    email: string = "";
    inn: string = "";
    snils: string = "";
}

// export class ComplianceData {
//     complianceDataApproved: boolean = null;
//     incomeSources: IncomeSource = null;
// }

// export class SalesData {
//     promoCode: string = "";
//     comments: string = "";
// }

// export class Account {
//     number: string = "";
//     bic: string = "";
//     type: string = "";
//     currency: string = "";
//     name: string = "";
//     availableBalance: number = null;
//     cardNumber: string = "";
// }

// export class IncomeSource {
//     salary: boolean = null;
//     business: boolean = null;
//     stocks: boolean = null;
//     derivatives: boolean = null;
//     forex: boolean = null;
//     inheritance: boolean = null;
//     donation: boolean = null;
//     loan: boolean = null;
//     another: boolean = null;
//     anotherText: string = "";
// }
